import { render, staticRenderFns } from "./Lista-saldo-proveedores.vue?vue&type=template&id=63f7110e"
import script from "./Lista-saldo-proveedores.vue?vue&type=script&lang=js"
export * from "./Lista-saldo-proveedores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports